import { UserListScreen } from "@/features/staff/users";

export default function UsersPage() {
  return <UserListScreen />;
}
